<template>
  <th v-show="showColumn">
    <a v-if="sortEnabled" class="sorting" v-on:click="sortColumn(name)">
      <span class="colname">
          {{ $t('tableheadings.' + name) }}
      </span>
      <span class="colsort">
        <font-awesome-icon v-if="sort !== name" :icon="['fal','sort']"></font-awesome-icon>
        <font-awesome-icon v-if="sort === name && dir === 'asc'" :icon="['fal','sort-down']"></font-awesome-icon>
        <font-awesome-icon v-if="sort === name && dir === 'desc'" :icon="['fal','sort-up']"></font-awesome-icon>
      </span>
    </a>

    <span v-else class="colname">
      {{ $t('tableheadings.' + name) }}
    </span>
  </th>
</template>

<script>
export default {
  name: 'TableHeading',

  props: {
    name: String,
    selected: Array,
    sortEnabled: Boolean,
    sort: String,
    dir: String
  },

  computed: {
    showColumn () {
      return this.selected.indexOf(this.name) !== -1
    }
  },

  methods: {
    sortColumn (column) {
      this.$emit('notifysort', column)
    }
  }
}
</script>
